/* eslint-disable react/forbid-prop-types */
import React from 'react';
import * as XLSX from 'xlsx';
import { Row, Button } from 'reactstrap';
import moment from 'moment';
import PropTypes from 'prop-types';
import { setCurrencyFormat } from '../../../../utils/helpers';
import ResizableDataTable from '../../../Tables/ResizableTable/components/ResizableReactTable';



const ViewsVsSalesTable = ({ data, tableHeaderData }) => {
    const excelData = data?.length && data.map((item) => {
        const updated = { ...item };
        const { reportDate, sessions, sessionsPercentage, pageViews, pageViewsPercentage,
            buyBoxPercentage, unitsOrdered, unitsOrderedB2B, unitSessionPercentage,
            unitSessionPercentageB2B, orderedProductSales, orderedProductSalesB2B,
            totalOrderItems, totalOrderItemsB2B, orderCount } = updated
        updated.reportDate = moment(reportDate).format('MM-DD-YYYY');
        updated.sessions = setCurrencyFormat(Number(sessions).toFixed(0), false);
        updated.sessionsPercentage = `${Number(sessionsPercentage).toFixed(0)} %`;
        updated.pageViews = setCurrencyFormat(Number(pageViews).toFixed(0), false);
        updated.pageViewsPercentage = `${Number(pageViewsPercentage).toFixed(0)} %`;
        updated.buyBoxPercentage = `${Number(buyBoxPercentage).toFixed(0)} %`;
        updated.unitsOrdered = setCurrencyFormat(Number(unitsOrdered).toFixed(0), false);
        updated.unitsOrderedB2B = setCurrencyFormat(Number(unitsOrderedB2B).toFixed(0), false);
        updated.unitSessionPercentage = `${Number(unitSessionPercentage).toFixed(0)} %`;
        updated.unitSessionPercentageB2B = `${Number(unitSessionPercentageB2B).toFixed(2)} %`
        updated.orderedProductSales = setCurrencyFormat(Number(orderedProductSales).toFixed(2), true);
        // eslint-disable-next-line max-len
        updated.orderedProductSalesB2B = setCurrencyFormat(Number(orderedProductSalesB2B).toFixed(2), true);
        updated.totalOrderItems = setCurrencyFormat(Number(totalOrderItems).toFixed(0), false);
        updated.totalOrderItemsB2B = setCurrencyFormat(Number(totalOrderItemsB2B).toFixed(0), false);
        updated.orderCount = setCurrencyFormat(Number(orderCount).toFixed(0), false);
        return updated

    })

    const handleDownload = () => {
        if (!data.length) return;

        // Create a new workbook
        const wb = XLSX.utils.book_new();

        // Create headers array from tableHeaderData
        const headers = tableHeaderData?.map(col => col.Header) || [];

        // Create data array with only the fields specified in tableHeaderData
        const worksheetData = excelData?.map(row => {
            const filteredRow = {};
            tableHeaderData?.forEach(col => {
                filteredRow[col.Header] = row[col.accessor];
            });
            return filteredRow;
        }) || [];

        // Convert data to worksheet format with proper headers
        const ws = XLSX.utils.json_to_sheet(worksheetData, { header: headers });

        // Add worksheet to workbook
        XLSX.utils.book_append_sheet(wb, ws, 'report');

        // Write the file
        XLSX.writeFile(wb, 'Page Traffic (Views Vs Sales) With Conversion.xlsx');
    };

    return (
        <Row style={{ position: 'relative' }}>
            <div className="ExcelTable" id='dvTable'>

                <Button
                    disabled={!data.length}
                    className="download-monthly-sub-order-report btn-primary btn btn-sm"
                    onClick={handleDownload}
                >
                    Download
                </Button>
            </div>
            <ResizableDataTable customClass="pt-0" reactTableData={{ tableHeaderData }} data={data} />
        </Row>
    )
}

ViewsVsSalesTable.propTypes = {
    data: PropTypes.array.isRequired,
    tableHeaderData: PropTypes.array.isRequired,
};


export default ViewsVsSalesTable;